import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "product-card-media__spacer" }, null, -1)
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "product-card-media__overlay" }, null, -1)

import { onMounted, ref, computed, onBeforeUnmount } from 'vue';

import { useLazyLoad } from '@/composables/useLazyLoad';
import { debounce } from '@/utils';
import { deviceWidths } from '../../constants';

import ContentCarousel from '../ContentCarousel.vue';
import SliderIndicator from '../SliderIndicator.vue';
import CarouselArrow from '../svg/CarouselArrow.vue';
import { useScrollDetector } from '@/composables/useWindowScroll';

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'ProductCardMedia',
  props: {
  alt: {
    type: String,
    required: true,
  },
  images: {
    type: Array,
    required: true,
  },
  isCardHovered: {
    type: Boolean,
    default: false,
  },
  reinitializeImagesOnResize: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props



const disableInfiniteSlider = false;
const MissingImage = require('../../static/images/missing_image_product_card.svg');

const carousel = ref<InstanceType<typeof ContentCarousel> | null>(null);
const imgUrls = ref<Array<string>>([]);
const currentSlide = ref<number>(0);
const isPhoneDevice = ref<boolean>(false);
const { isPageScrolling } = useScrollDetector('product-card');

const checkWindowWidth = debounce(() => {
  isPhoneDevice.value = window.innerWidth <= deviceWidths.tabletMaxWidth;
}, 150);

const isProductCardHovered = computed(() => props.isCardHovered);

const displaySliderIndicator = computed(
  () =>
    imgUrls.value.length > 1 &&
    (isPhoneDevice.value || isProductCardHovered.value)
);

const displayArrows = computed(() => {
  return (
    imgUrls.value.length > 1 &&
    !isPhoneDevice.value &&
    isProductCardHovered.value
  );
});

const displayLeftArrow = computed(() =>
  disableInfiniteSlider ? currentSlide.value > 1 : true
);

const displayRightArrow = computed(() =>
  disableInfiniteSlider ? currentSlide.value < imgUrls.value.length : true
);

const el = ref<HTMLElement | null>(null);

useLazyLoad(
  el,
  () => {
    imgUrls.value = [];
    imgUrls.value = props.images as string[];
  },
  { reinitializeOnResize: props.reinitializeImagesOnResize }
);

function prevSlide(slideSpeed = 0.15) {
  if (carousel.value) {
    carousel.value.go(-1, slideSpeed);
  }
}

function nextSlide(slideSpeed = 0.15) {
  if (carousel.value) {
    carousel.value.go(1, slideSpeed);
  }
}

function slideDidChange(slide) {
  currentSlide.value = slide;
}

function onMissingImageError(event: any) {
  event.target.src = MissingImage;
}

onMounted(() => {
  isPhoneDevice.value = window.innerWidth <= deviceWidths.tabletMaxWidth;
  window.addEventListener('resize', checkWindowWidth);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', checkWindowWidth);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "el",
    ref: el,
    class: _normalizeClass(["product-card-media", { 'product-card-media--empty': !imgUrls.value.length }])
  }, [
    (imgUrls.value.length > 0)
      ? (_openBlock(), _createBlock(ContentCarousel, {
          key: imgUrls.value.length,
          class: "product-card-media__media-carousel",
          ref_key: "carousel",
          ref: carousel,
          disableInfiniteSlider: disableInfiniteSlider,
          onSlideDidChange: slideDidChange,
          tempFrozen: _unref(isPageScrolling) || false
        }, {
          overlay: _withCtx(() => [
            (_unref(displayArrows) && _unref(displayLeftArrow))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "product-card-media__carousel-nav product-card-media__carousel-nav--left",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (prevSlide()), ["stop","prevent"]))
                }, [
                  _createVNode(CarouselArrow, { class: "product-card-media__arrow product-card-media__arrow--left" })
                ]))
              : _createCommentVNode("", true),
            (_unref(displayArrows) && _unref(displayRightArrow))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "product-card-media__carousel-nav",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (nextSlide()), ["stop","prevent"]))
                }, [
                  _createVNode(CarouselArrow, { class: "product-card-media__arrow" })
                ]))
              : _createCommentVNode("", true),
            (_unref(displaySliderIndicator))
              ? (_openBlock(), _createBlock(SliderIndicator, {
                  key: 2,
                  class: "product-card-media__slide-line",
                  slides: imgUrls.value.length,
                  "current-slide": currentSlide.value
                }, null, 8, ["slides", "current-slide"]))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imgUrls.value, (image, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: image + i,
                class: "product-card-media__media-carousel-item-container"
              }, [
                _hoisted_1,
                _createElementVNode("img", {
                  class: "product-card-media__image",
                  src: image,
                  loading: "lazy",
                  onError: onMissingImageError,
                  alt: __props.alt
                }, null, 40, _hoisted_2),
                _hoisted_3
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["tempFrozen"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})